export const BodyCopyStyle = {
  fontFamily: "'Inter', sans-serif",
  fontSize: '16px',
  fontWeight: '400',
  lineHeight: '24px',
  letterSpacing: '0.4px',
  color: '#1D1C1C',
};

export const LabelStyle = {
  fontFamily: "'Inter', sans-serif",
  fontSize: '12px',
  fontWeight: '400',
  lineHeight: '16px',
  letterSpacing: '0.5px',
  color: '#666',
  textTransform: 'uppercase',
};
